import { Injectable } from '@angular/core';
import { IacIconInterface } from '@iac-types';

@Injectable({
  providedIn: 'root',
})
export class IconsRegistry {
  private registry = new Map<string, string>();

  public registerIcons(icons: IacIconInterface[]): void {
    icons.forEach((icon: IacIconInterface) => this.registry.set(icon.name, icon.data));
  }

  public getIcon(iconName: string): string | undefined {
    if (!this.registry.has(iconName)) {
      console.warn(
        `Icon "${iconName}" not found in the registry. Did you register it via IconsRegistry.registerIcons()?`
      );
    }
    return this.registry.get(iconName);
  }
}
